import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {
    getIndustryDimensionsValuesByIndustryName,
    getIndustryTouchpoints
} from "../../../../../actions";
import IndustryDimensionValues from "./industryDimensionValues";
import { deleteDimensionIndustry } from "../../../../../actions/dimensionsIndustryActions";

const mapStateToProps = (state) => ({
    industryDimensionsValueList: state.dimensionIndustry,
    industryTouchpointsList: state.industryTouchpoints,
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            getIndustryDimensionsValuesByIndustryName,
            deleteDimensionIndustry,
            getIndustryTouchpoints
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(IndustryDimensionValues);

